import { render, staticRenderFns } from "./LinksFooter.vue?vue&type=template&id=016994e8&lang=html&"
import script from "./LinksFooter.vue?vue&type=script&lang=ts&"
export * from "./LinksFooter.vue?vue&type=script&lang=ts&"
import style0 from "./LinksFooter.vue?vue&type=style&index=0&id=016994e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports